import React from 'react';
import styled from 'styled-components';
import { Typography } from '@fupa/fupa-uikit';
import { MatchFlag } from 'app/types/match/MatchFlags';
const FinishedInfo = styled(Typography).withConfig({
  componentId: "sc-wvmtz0-0"
})(["&&&{position:absolute;bottom:-0.5rem;}"]);
const FlagLabel = {
  [MatchFlag.Penalty]: 'n.E.',
  [MatchFlag.Overtime]: 'n.V.',
  [MatchFlag.Verdict]: 'Urteil',
  [MatchFlag.Aborted]: 'Abbr.'
};
export default function MatchResultTeaserResultHint(_ref) {
  let {
    flags
  } = _ref;
  if (!flags || !Object.keys(FlagLabel).some(flag => flags.includes(flag))) {
    return null;
  }
  const flagKey = Object.keys(FlagLabel).find(flag => flags.includes(flag));
  return /*#__PURE__*/React.createElement(FinishedInfo, {
    variant: 'caption1',
    "data-sentry-element": "FinishedInfo",
    "data-sentry-component": "MatchResultTeaserResultHint",
    "data-sentry-source-file": "MatchResultTeaserResultHint.tsx"
  }, FlagLabel[flagKey]);
}